import React from "react";
import SkeyechartsDashboardsTable from "./SkeyechartsDashboardsTable";
import { fetchDashboards } from "./SkeyechartDashboardsAPI";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import skeyechartsDashboardsHelp from "../../../content/help/skeyecharts-dashboards.json";

export default function SkeyechartsDashboards({
  pageTitle = "Skeyechart Dashboards",
}) {
  usePageTitle("SkeyeCharts Dashboards - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    contextHolder,
    handleSearch,
    clearFilter,
    onPageChange,
  } = usePageState({
    fetchFn: fetchDashboards,
    filterFields: [(d) => d.id?.toString(), "dashboard_title"],
  });

  return (
    <div className="skeyecharts-dashboards-page">
      {contextHolder}
      <PageLayout
        title={pageTitle}
        logo="/img/majesteye-icon-skeye-charts-square-white-background-no-label"
        description="Manager for Skeyecharts dashboards, allowing you to access all the dashboards."
        helpContent={skeyechartsDashboardsHelp}
      >
        <SearchToolbar
          search={searchText}
          onSearchChange={handleSearch}
          onClearFilter={clearFilter}
        />

        <SkeyechartsDashboardsTable
          data={filteredData}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      </PageLayout>
    </div>
  );
}
